import { toast } from "react-toastify";
import { setWelcomeToast } from "../slices/welcomeToaster/action";
import 'react-toastify/dist/ReactToastify.css';

export const handleLoginSuccess = (response, dispatch, setLoading, navigate) => {
  const { accessToken, refreshToken, userId, roleName, operatorId, permissions, userName, operatorName,customerId } = response;
  var jsonString = JSON.stringify(permissions);

  localStorage.setItem('token', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('userId', userId);
  localStorage.setItem('roleName', roleName);
  localStorage.setItem('operatorId', operatorId);
  localStorage.setItem('permissionss', jsonString);
  localStorage.setItem('userName', userName);
  localStorage.setItem('operatorName', operatorName);
  {roleName === "Customer" ? localStorage.setItem("customerId",customerId) : null}
  {roleName==='ISPPartnerAdmin'?
  localStorage.setItem('PartnerId', operatorId.split('/').pop()):null}
  localStorage.setItem('dateFormat', "DD MMM YYYY");


  if (
    response &&
    response.permissions &&
    Array.isArray(response.permissions)
  ) {
    // For Some Reason her login Response We are using from previous structure This will be Changed in Near Future
    const hasDashboardPermission = response?.permissions?.some(
      (permission) => permission?.resourceName === 'dashboard' || permission?.module === "Dashboard"
    );
    const hasCustomerPermission = permissions?.some(permission => permission?.resourceName === 'customer' || permission?.module === "Customer");
    const hasUserPermission = permissions?.some(permission => permission?.resourceName === 'userManagement' || (permission?.module === "Administration" && permission?.submodules?.some(sub => sub?.submodule === "userManagement")));
    setLoading(false)
    if (hasDashboardPermission) {
      navigate('/dashboard');
    } else if (hasCustomerPermission) {
      navigate('/customer');
    } else if ((roleName === "SGCExecutiveUser" || roleName === "SGCPowerUser" || roleName === "SGCOperationsUser") && hasUserPermission){
      navigate('/user');
    } else if(roleName === "systemUser"){
      navigate('/operator-listing');
    } else {
      navigate('/dashboard');
    }
  }
  dispatch(setWelcomeToast(true));
};

export const handleLoginFailure = (error, setLoading) => {
  setLoading(false);
  toast.error(error);
};
